import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'loading-page',
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss']
})
export class LoadingPageComponent implements OnInit {

  @Input() diameter = '40';
	@Input() color = 'accent';

  constructor() { }

  ngOnInit(): void {
  }

}
